/**
 * @module Section-Shared-ITSolutions
 */

import { NavLink, useNavigate } from "react-router-dom";
import { navUrl, publicUrlFor } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionIT } from "../../../@types/sectionTypes";

/**
 * 
 * @param props : Data supplied to display IT solutions
 * @returns Markup for IT solutions section
 */
const SectionSharedITSolutions = (
    props: {
        _it: TypeSectionIT
    }
) => {
    const { _it } = props;
    const navigate = useNavigate();

    const handleDiscoverMore = (e: React.MouseEvent) => {
        e.preventDefault();
        const currentPath = window.location.pathname;
        
        if (currentPath !== '/') {
            navigate('/#services');
        } else {
            const $services = (window as any).$ ? (window as any).$('#services') : null;
            if ($services && $services.length) {
                (window as any).$('html, body').stop().animate({
                    scrollTop: $services.offset().top
                }, {
                    duration: 1000,
                    complete: function() {
                        if (window.location.hash === '#services') {
                            window.history.replaceState(null, '', window.location.pathname + window.location.search);
                        }
                        (window as any).$('html, body').css({ overflow: '', height: '' });
                    }
                });
            }
        }
    };

    return (
        <div className="section-full av-itsolution-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2" style={{ backgroundImage: `url(${publicUrlFor(_it.image)})` }}>
            <div className="container">
                <div className="av-itsolution-section">
                    <h2 className="av-title">{_it.title}</h2>
                    <h3 className="av-title2">{_it.subtitle}</h3>
                    <p>{_it.description}</p>
                    <button onClick={handleDiscoverMore} className="site-button on-bg">
                        Discover More
                        <i className="fa fa-plus" />
                    </button>
                </div>
            </div>
        </div>
    )
}
export default SectionSharedITSolutions;